export const audit_log = {
    name: 'audit_log',
    params: {
        entityConfig: {
            name: 'audit_log',
            get: ['lastRecords', 'log'],
        }
    }
};
